import { render, staticRenderFns } from "./FrrHowTo.vue?vue&type=template&id=15872f06&scoped=true&"
import script from "./FrrHowTo.vue?vue&type=script&lang=js&"
export * from "./FrrHowTo.vue?vue&type=script&lang=js&"
import style0 from "./FrrHowTo.vue?vue&type=style&index=0&id=15872f06&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15872f06",
  null
  
)

export default component.exports